import { useAuth } from "@/modules/auth/hooks/useAuth";

// Whether the authenticated user's organization issues cards on the provider that
// uses an SMS one-time code (3DS) sent to the cardholder's phone. Gates the 3DS
// phone hint so it only shows for orgs where it applies — the provider name is
// never rendered, only its internal enum value is compared here.
export function useIsCryptomateOrg(): boolean {
  const { user } = useAuth();
  return String(user?.organization?.card_provider ?? "").toUpperCase() === "CRYPTO_MATE";
}
